var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _path12, _g2, _path13, _g3, _path14, _g4, _path15, _g5, _path16, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8825 14.5652C22.1765 15.7873 22.3002 16.0426 22.3389 16.6846C22.3853 17.373 22.4704 17.8371 22.4549 18.2548C22.4395 18.5951 22.0682 19.7245 20.3587 21.3488C18.8581 22.7798 17.6128 23.2362 17.1796 23.2517C16.8006 23.2671 16.6536 23.1511 15.7486 23.0428C14.6502 22.9113 13.3121 22.7102 12.0822 22.2229C10.744 21.6969 9.60696 20.5985 8.98042 20.0184C8.01353 19.1366 5.91732 16.731 5.0974 15.8337C4.15372 14.8281 1.38456 11.6954 0.696138 10.775C0.0928011 9.97052 0.162417 9.11192 0.665198 8.62461C1.29947 8.0058 2.01884 8.30747 2.48294 8.7097C3.12495 9.26662 4.50954 10.6203 5.29851 11.3319C6.08749 12.0435 8.94174 14.627 8.94174 14.627C8.94174 14.627 9.75392 13.2425 10.7285 12.175C11.9507 10.8291 12.9949 10.0247 12.9949 10.0247C12.9949 10.0247 11.6181 8.84893 9.70751 7.05439C7.80468 5.25985 6.2654 3.77471 5.87865 3.41116C5.3836 2.95479 4.55595 1.98791 5.47642 0.974609C6.42784 -0.054157 7.41019 0.696146 7.96712 1.19119C8.47763 1.63209 10.5661 3.51172 12.3529 5.22891C15.563 8.30747 17.4503 8.74064 17.4503 8.74064L20.9157 12.4767L21.8825 14.5652Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8825 14.5652C22.1765 15.7873 22.3002 16.0426 22.3389 16.6846C22.3853 17.373 22.4704 17.8371 22.4549 18.2548C22.4395 18.5951 22.0682 19.7245 20.3587 21.3488C18.8581 22.7798 17.6128 23.2362 17.1796 23.2517C16.8006 23.2671 16.6536 23.1511 15.7486 23.0428C14.6502 22.9113 13.3121 22.7102 12.0822 22.2229C10.744 21.6969 9.60696 20.5985 8.98042 20.0184C8.01353 19.1366 5.91732 16.731 5.0974 15.8337C4.15372 14.8281 1.38456 11.6954 0.696138 10.775C0.0928011 9.97052 0.162417 9.11192 0.665198 8.62461C1.29947 8.0058 2.01884 8.30747 2.48294 8.7097C3.12495 9.26662 4.50954 10.6203 5.29851 11.3319C6.08749 12.0435 8.94174 14.627 8.94174 14.627C8.94174 14.627 9.75392 13.2425 10.7285 12.175C11.9507 10.8291 12.9949 10.0247 12.9949 10.0247C12.9949 10.0247 11.6181 8.84893 9.70751 7.05439C7.80468 5.25985 6.2654 3.77471 5.87865 3.41116C5.3836 2.95479 4.55595 1.98791 5.47642 0.974609C6.42784 -0.054157 7.41019 0.696146 7.96712 1.19119C8.47763 1.63209 10.5661 3.51172 12.3529 5.22891C15.563 8.30747 17.4503 8.74064 17.4503 8.74064L20.9157 12.4767L21.8825 14.5652Z",
    fill: "#FFCE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8825 14.5652C22.1765 15.7873 22.2693 16.0426 22.308 16.6846C22.3544 17.373 22.4704 17.8371 22.4472 18.2548C22.4317 18.5951 22.0604 19.7245 20.351 21.3488C18.8504 22.7798 17.605 23.2362 17.1719 23.2517C16.7929 23.2671 16.6459 23.1511 15.7409 23.0428C14.6425 22.9113 13.3043 22.7102 12.0744 22.2229C10.7363 21.6969 9.59922 20.5985 8.97268 20.0184C8.00579 19.1366 5.90959 16.731 5.08967 15.8337C4.15372 14.8281 1.38456 11.6954 0.696138 10.775C0.0928011 9.97052 0.162417 9.11192 0.665198 8.62461C1.29947 8.0058 2.01884 8.30747 2.48294 8.7097C3.12495 9.26662 4.50954 10.6203 5.29851 11.3319C6.08749 12.0435 8.94174 14.627 8.94174 14.627C8.94174 14.627 9.75392 13.2425 10.7285 12.175C11.9507 10.8291 12.9949 10.0247 12.9949 10.0247C12.9949 10.0247 11.6181 8.84893 9.70751 7.05439C7.80468 5.25985 6.2654 3.77471 5.87865 3.41116C5.3836 2.95479 4.55595 1.98791 5.47642 0.974609C6.42784 -0.054157 7.41019 0.696146 7.96712 1.19119C8.47763 1.63209 10.5661 3.51172 12.3529 5.22891C15.563 8.30747 17.4503 8.74064 17.4503 8.74064L20.9157 12.4767L21.8825 14.5652Z",
    fill: "#FFCE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.928204 5.2057C0.170166 6.02562 0.758032 6.96157 1.28402 7.50302C1.74812 7.99033 2.39787 8.64008 3.44211 9.6147C4.68746 10.775 8.97269 14.6889 8.97269 14.6889C8.97269 14.6889 9.3053 14.0624 9.80035 13.3972C10.2877 12.7319 10.7595 12.1905 10.7595 12.1905C10.7595 12.1905 3.72831 5.75489 3.14817 5.25211C2.64539 4.81895 1.73265 4.3239 0.928204 5.2057Z",
    fill: "#FFCE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20447 2.11941C1.4387 2.93933 1.96469 3.91395 2.48294 4.46314C2.94704 4.95045 3.60453 5.61567 4.63329 6.59803C5.86317 7.76603 10.744 12.2988 10.744 12.2988C10.744 12.2988 11.2081 11.7341 11.8115 11.1617C12.4303 10.5816 13.08 10.0633 13.08 10.0633C13.08 10.0633 5.07419 2.66087 4.5018 2.15035C3.99902 1.71719 3.02439 1.25308 2.20447 2.11941Z",
    fill: "#FFCE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7718 9.78487C15.71 10.744 14.7972 11.4092 14.9365 13.1264C14.9983 13.9386 15.7564 15.0679 15.7564 15.0679L17.9454 12.9408L20.0803 11.2081L17.4581 8.74063C17.4581 8.74063 16.3288 8.47764 14.3254 6.93835C14.4337 7.02344 15.8879 7.99033 15.7718 9.78487Z",
    fill: "#F7B208"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28956 3.18686C2.04204 2.34374 2.72273 1.74814 2.7382 1.73267C2.56029 1.81002 2.37465 1.93378 2.20447 2.11942C1.4387 2.93934 1.96469 3.91396 2.48294 4.46315C2.94704 4.95046 3.60453 5.61568 4.63329 6.59804C5.61565 7.53398 8.91853 10.6048 10.218 11.8037C10.5429 12.1054 10.1484 12.469 10.1484 12.469C10.1484 12.469 10.8987 12.1054 11.1462 11.8347L11.796 10.7286C11.796 10.7286 10.9451 11.4866 10.218 10.8523C9.61469 10.3341 8.69421 9.46775 8.36934 9.16608C8.03673 8.87215 7.3251 8.29975 6.78365 7.81244C6.24992 7.32513 5.94052 7.03894 5.16701 6.32731C4.48633 5.71624 3.7979 4.99687 3.53491 4.73388C2.97798 4.16922 2.46747 3.79793 2.28956 3.18686Z",
    fill: "#F7B208"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.990085 5.92506C0.904999 5.22117 1.37684 4.84988 1.37684 4.84988C1.22214 4.92723 1.07517 5.04326 0.928204 5.2057C0.170166 6.02562 0.758032 6.96156 1.28402 7.50302C1.74812 7.99033 2.39787 8.64008 3.44211 9.6147C4.26976 10.3882 6.44332 12.3761 7.8047 13.6215C8.05995 13.8535 8.28427 14.0624 8.46991 14.2248C8.78705 14.511 8.52406 15.1375 8.52406 15.1375C8.52406 15.1375 9.4368 13.4513 9.63791 13.1342C9.63791 13.1342 9.2821 13.5519 8.94949 13.5519C8.62461 13.5596 8.53179 13.4822 7.92846 12.9485C7.32512 12.4148 7.1008 11.9971 6.41238 11.3628C5.72396 10.7285 4.32391 9.58376 3.59681 8.96495C3.15591 8.59367 2.75368 8.029 1.97244 7.41793C1.45419 7.02344 1.07517 6.60575 0.990085 5.92506Z",
    fill: "#F7B208"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.351 20.9621C19.3996 21.8361 18.2548 22.7179 17.2725 22.7876C16.4061 22.8494 16.2127 22.7102 15.2381 22.5091C14.395 22.3312 13.343 22.2306 12.1518 21.6814C11.3628 21.3179 10.3882 20.6836 9.3904 19.7399C7.71189 18.1465 6.65991 16.8161 5.15931 15.2381C4.31618 14.3486 0.982361 10.8369 0.618812 9.62245C0.4177 8.92629 0.928215 8.43124 0.928215 8.43124C0.843129 8.48539 0.750308 8.54727 0.665222 8.63236C0.170177 9.11967 0.092826 9.97826 0.696163 10.7827C1.37685 11.7032 4.14601 14.8359 5.08196 15.8569C5.90188 16.7542 7.99808 19.1598 8.96497 20.0416C9.59151 20.614 10.7286 21.7201 12.0667 22.2461C13.3044 22.7334 14.6348 22.9268 15.7332 23.066C16.6459 23.1743 16.7851 23.2903 17.1642 23.2749C17.6051 23.2517 18.8427 22.7953 20.3433 21.372C21.403 20.3587 21.9522 19.5466 22.2152 18.9896C22.2306 18.9742 21.2406 20.1422 20.351 20.9621Z",
    fill: "#F7B208"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29201 16.0813C8.38483 16.1045 9.03458 14.4878 11.0457 12.3065C13.3508 9.80036 14.7353 9.16609 14.7353 9.081C14.7353 8.99591 12.9485 9.31305 10.6357 11.8966C8.47765 14.2867 8.19919 16.058 8.29201 16.0813Z",
    fill: "#F7B208"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87869 0.64975C5.74719 0.727101 5.61569 0.835392 5.4842 0.982358C4.55599 1.98792 5.39138 2.95481 5.88642 3.41891C6.27318 3.78246 7.81246 5.25986 9.72302 7.0544C10.8756 8.12958 11.827 8.98817 12.4071 9.49869C12.7088 9.76168 12.7474 9.93185 12.5154 10.1562L14.0237 9.2589C14.0237 9.2589 13.4359 9.47548 12.848 9.21249C12.5463 9.07326 12.1054 8.65556 11.7651 8.3539C11.2546 7.90526 10.7827 7.40248 10.4965 7.13949C10.1485 6.81461 9.71529 6.27316 8.84896 5.49191C8.07545 4.79576 7.64229 4.43994 6.96933 3.84434C6.29638 3.20233 5.46873 2.52164 5.38364 1.95698C5.25214 1.13706 5.83228 0.69616 5.87869 0.64975Z",
    fill: "#F7B208"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6326 15.532C15.6326 15.532 15.1376 14.1629 15.4238 12.7165C15.7564 11.038 16.3597 10.3573 16.4061 9.05778C16.4371 8.03675 15.8492 6.67537 16.4138 5.11288C17.0791 3.2642 18.7576 3.49625 18.7576 3.49625C18.7576 3.49625 19.1289 4.53275 19.3532 5.21344C19.5852 5.88639 20.0261 6.88422 20.1963 7.61132C20.3897 8.44671 20.3974 9.723 20.6295 10.7518C20.8693 11.8424 21.2947 12.8248 21.2947 12.8248L15.6326 15.532Z",
    fill: "#FFCE00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_901_284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 7,
    height: 15
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9144 3.65097C18.1465 3.55041 18.6957 3.55042 18.6957 3.55042C18.6957 3.55042 19.2604 5.34495 19.4924 6.08752C19.6935 6.7218 19.8405 7.86659 19.8792 8.4854C19.9178 9.11194 19.8405 10.512 19.9874 11.2081C20.1344 11.9043 21.1787 14.3022 21.4107 15.1221C21.6428 15.942 21.4339 16.9398 21.4339 16.9398C21.4339 16.9398 20.0339 17.3421 18.4327 16.878C17.0481 16.4757 16.0271 15.5011 15.8028 15.1608C15.6326 14.8978 15.3851 13.9464 15.7177 12.8403C16.0039 11.8966 16.6846 10.891 16.9553 9.59925C17.2183 8.30749 16.437 7.38702 16.731 5.90188C17.0481 4.33939 17.6824 3.75153 17.9144 3.65097Z",
    fill: "url(#paint0_linear_901_284)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_901_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9144 3.65097C18.1465 3.55041 18.6957 3.55042 18.6957 3.55042C18.6957 3.55042 19.2604 5.34495 19.4924 6.08752C19.6935 6.7218 19.8405 7.86659 19.8792 8.4854C19.9178 9.11194 19.8405 10.512 19.9874 11.2081C20.1344 11.9043 21.1787 14.3022 21.4107 15.1221C21.6428 15.942 21.4339 16.9398 21.4339 16.9398C21.4339 16.9398 20.0339 17.3421 18.4327 16.878C17.0481 16.4757 16.0271 15.5011 15.8028 15.1608C15.6326 14.8978 15.3851 13.9464 15.7177 12.8403C16.0039 11.8966 16.6846 10.891 16.9553 9.59925C17.2183 8.30749 16.437 7.38702 16.731 5.90188C17.0481 4.33939 17.6824 3.75153 17.9144 3.65097Z",
    fill: "url(#paint1_linear_901_284)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8702 9.20477C16.8857 8.10638 16.3906 7.69643 16.6072 6.02565C16.7851 4.6488 17.7288 3.68192 17.7288 3.68192H17.6592C17.2028 3.88303 16.7078 4.29299 16.4138 5.11291C15.8492 6.67539 16.4371 8.03677 16.4061 9.0578C16.3597 10.365 15.7564 11.038 15.4238 12.7165C15.1376 14.163 15.6326 15.5321 15.6326 15.5321C15.6326 15.5321 15.2613 13.9928 15.6017 12.8093C15.9343 11.6336 16.8547 10.3031 16.8702 9.20477Z",
    fill: "#F7B208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6858 6.103C19.6858 6.103 19.7167 6.58257 19.9333 7.82019C20.1499 9.0578 19.8328 10.3728 20.3123 11.9585C20.7919 13.5441 21.4494 14.4801 21.6041 15.1995C21.7588 15.9266 21.7124 16.3984 21.8903 16.9631C22.0682 17.5355 22.3389 18.7267 22.3389 18.7267C22.6019 18.1156 22.4317 17.3266 22.3312 16.6459C22.2384 16.0116 22.3312 15.2691 22.0682 14.542C21.898 14.163 21.2947 12.8325 21.2947 12.8325C21.2947 12.8325 20.8693 11.8502 20.6295 10.7595C20.4052 9.72302 20.3974 8.44673 20.1963 7.61907C20.088 7.1627 19.8792 6.61351 19.6858 6.103Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5905 14.3563C13.5905 14.3563 12.8866 15.9188 13.4436 16.9089C13.9773 17.8603 16.6459 18.6416 16.6459 18.6416L12.964 18.0614L12.0435 17.5432L11.8579 16.994L12.5772 16.0735L13.5905 14.3563Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5376 15.4934C16.5376 15.4934 17.4194 16.3597 18.3554 16.7697C19.2913 17.1797 20.3588 17.2183 20.3588 17.2183C20.3588 17.2183 19.2836 17.4659 18.278 16.9708C17.2802 16.468 16.5376 15.4934 16.5376 15.4934Z",
    fill: "#FFB600"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_901_284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 9,
    height: 10
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.935944 8.69424C0.440898 9.20475 0.858593 9.99373 1.12932 10.3728C2.6686 12.5618 7.47983 17.4426 7.47983 17.4426C7.47983 17.4426 7.55718 16.5299 7.8279 15.8569C8.10637 15.184 8.45445 14.6503 8.45445 14.6503C8.45445 14.6503 2.67634 9.00364 2.35146 8.71744C2.03433 8.42351 1.43099 8.19146 0.935944 8.69424Z",
    fill: "url(#paint2_linear_901_284)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_901_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.935944 8.69424C0.440898 9.20475 0.858593 9.99373 1.12932 10.3728C2.6686 12.5618 7.47983 17.4426 7.47983 17.4426C7.47983 17.4426 7.55718 16.5299 7.8279 15.8569C8.10637 15.184 8.45445 14.6503 8.45445 14.6503C8.45445 14.6503 2.67634 9.00364 2.35146 8.71744C2.03433 8.42351 1.43099 8.19146 0.935944 8.69424Z",
    fill: "url(#paint3_linear_901_284)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_901_284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 10,
    height: 10
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32269 5.05103C1.85641 4.4941 2.80783 5.05103 3.10176 5.29855C3.5736 5.70077 8.33841 10.2258 8.77158 10.6203C9.20474 11.0148 10.1562 11.8115 10.2103 12.0435C10.2645 12.2756 9.47547 13.1961 9.18927 13.3662C8.91081 13.5364 8.44671 13.258 7.97486 12.7938C7.46435 12.2833 7.19362 11.9275 6.59028 11.3397C6.02562 10.7982 3.89847 9.04233 3.50399 8.69425C3.11723 8.34617 2.94706 8.09091 2.52163 7.7119C2.15808 7.38702 1.71718 7.12403 1.43098 6.69086C1.17572 6.31958 0.850851 5.53834 1.32269 5.05103Z",
    fill: "url(#paint4_linear_901_284)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_901_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.32269 5.05103C1.85641 4.4941 2.80783 5.05103 3.10176 5.29855C3.5736 5.70077 8.33841 10.2258 8.77158 10.6203C9.20474 11.0148 10.1562 11.8115 10.2103 12.0435C10.2645 12.2756 9.47547 13.1961 9.18927 13.3662C8.91081 13.5364 8.44671 13.258 7.97486 12.7938C7.46435 12.2833 7.19362 11.9275 6.59028 11.3397C6.02562 10.7982 3.89847 9.04233 3.50399 8.69425C3.11723 8.34617 2.94706 8.09091 2.52163 7.7119C2.15808 7.38702 1.71718 7.12403 1.43098 6.69086C1.17572 6.31958 0.850851 5.53834 1.32269 5.05103Z",
    fill: "url(#paint5_linear_901_284)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_901_284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 11,
    height: 11
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59897 2.05754C2.1658 2.54485 2.3205 3.08631 2.49841 3.43438C2.67632 3.78246 3.10175 4.15375 3.58906 4.64879C4.07637 5.14384 5.31398 6.32731 5.92505 6.8997C6.65215 7.58039 7.43339 8.27655 8.4699 9.15061C9.42131 9.95506 10.1329 10.8755 10.7208 11.007C11.3087 11.1385 11.7032 10.7286 11.9739 10.512C12.2369 10.2954 12.6004 10.1175 12.5927 9.86224C12.585 9.73074 11.796 9.03459 10.9838 8.29975C10.2567 7.64227 9.51413 6.95385 9.2202 6.67538C8.58592 6.09525 6.79912 4.33939 6.03334 3.65097C5.39133 3.07083 4.43218 2.04207 3.83658 1.80228C3.44983 1.65531 2.98572 1.61664 2.59897 2.05754Z",
    fill: "url(#paint6_linear_901_284)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_901_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59897 2.05754C2.1658 2.54485 2.3205 3.08631 2.49841 3.43438C2.67632 3.78246 3.10175 4.15375 3.58906 4.64879C4.07637 5.14384 5.31398 6.32731 5.92505 6.8997C6.65215 7.58039 7.43339 8.27655 8.4699 9.15061C9.42131 9.95506 10.1329 10.8755 10.7208 11.007C11.3087 11.1385 11.7032 10.7286 11.9739 10.512C12.2369 10.2954 12.6004 10.1175 12.5927 9.86224C12.585 9.73074 11.796 9.03459 10.9838 8.29975C10.2567 7.64227 9.51413 6.95385 9.2202 6.67538C8.58592 6.09525 6.79912 4.33939 6.03334 3.65097C5.39133 3.07083 4.43218 2.04207 3.83658 1.80228C3.44983 1.65531 2.98572 1.61664 2.59897 2.05754Z",
    fill: "url(#paint7_linear_901_284)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_901_284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 11,
    height: 10
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79357 0.874063C6.54387 0.108289 7.51076 0.951413 7.90525 1.26855C8.04448 1.37684 8.62461 1.90283 9.25115 2.46749C10.5584 3.65096 11.417 4.50955 12.0435 5.09742C12.6778 5.69302 14.4259 7.09307 14.7663 7.47209C15.1066 7.85111 15.1143 8.23787 14.8436 8.57047C14.3408 9.20475 13.8535 9.22022 13.5596 9.22796C13.2657 9.23569 13.0027 9.22796 12.4999 8.89535C12.2137 8.70197 11.2545 7.78149 10.4656 6.97705C9.97051 6.47427 9.42906 5.93281 9.11192 5.63114C8.67875 5.22118 8.01354 4.65652 7.27097 3.98357C6.59028 3.3725 6.05656 2.86198 5.92506 2.72275C5.66981 2.43655 4.99685 1.68625 5.79357 0.874063Z",
    fill: "url(#paint8_linear_901_284)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_901_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79357 0.874063C6.54387 0.108289 7.51076 0.951413 7.90525 1.26855C8.04448 1.37684 8.62461 1.90283 9.25115 2.46749C10.5584 3.65096 11.417 4.50955 12.0435 5.09742C12.6778 5.69302 14.4259 7.09307 14.7663 7.47209C15.1066 7.85111 15.1143 8.23787 14.8436 8.57047C14.3408 9.20475 13.8535 9.22022 13.5596 9.22796C13.2657 9.23569 13.0027 9.22796 12.4999 8.89535C12.2137 8.70197 11.2545 7.78149 10.4656 6.97705C9.97051 6.47427 9.42906 5.93281 9.11192 5.63114C8.67875 5.22118 8.01354 4.65652 7.27097 3.98357C6.59028 3.3725 6.05656 2.86198 5.92506 2.72275C5.66981 2.43655 4.99685 1.68625 5.79357 0.874063Z",
    fill: "url(#paint9_linear_901_284)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_901_284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 18,
    width: 11,
    height: 5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3641 18.4172C18.309 19.0283 19.709 20.9776 19.6394 21.2405C19.5698 21.5113 18.4559 22.5323 17.404 22.7102C17.2029 22.7489 16.8006 22.7721 16.3443 22.687C15.6404 22.5478 14.6812 22.3312 13.8613 22.1688C13.4049 22.0759 12.7165 21.8903 12.1054 21.5732C10.8059 20.9002 9.22025 19.7477 9.38269 19.1907C9.46777 18.9278 11.4866 17.9686 14.3641 18.4172Z",
    fill: "url(#paint10_linear_901_284)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_901_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3641 18.4172C18.309 19.0283 19.709 20.9776 19.6394 21.2405C19.5698 21.5113 18.4559 22.5323 17.404 22.7102C17.2029 22.7489 16.8006 22.7721 16.3443 22.687C15.6404 22.5478 14.6812 22.3312 13.8613 22.1688C13.4049 22.0759 12.7165 21.8903 12.1054 21.5732C10.8059 20.9002 9.22025 19.7477 9.38269 19.1907C9.46777 18.9278 11.4866 17.9686 14.3641 18.4172Z",
    fill: "url(#paint11_linear_901_284)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_901_284",
    x1: 18.7761,
    y1: 17.2974,
    x2: 17.3678,
    y2: 3.68436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_901_284",
    x1: 17.4286,
    y1: -0.172467,
    x2: 18.4297,
    y2: 13.5231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE63A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_901_284",
    x1: 7.70184,
    y1: 15.7774,
    x2: 0.89239,
    y2: 8.96792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_901_284",
    x1: 0.869991,
    y1: 8.40111,
    x2: 7.39871,
    y2: 15.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE63A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_901_284",
    x1: 8.75169,
    y1: 12.1495,
    x2: 1.39736,
    y2: 5.1413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_901_284",
    x1: 1.41403,
    y1: 4.58219,
    x2: 8.30126,
    y2: 12.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE63A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_901_284",
    x1: 11.864,
    y1: 10.6225,
    x2: 2.57553,
    y2: 2.16775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_901_284",
    x1: 6.27764,
    y1: 7.34274,
    x2: 8.20242,
    y2: 5.41797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE63A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_901_284",
    x1: 14.4936,
    y1: 8.99406,
    x2: 5.68872,
    y2: 0.889515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_901_284",
    x1: 9.12538,
    y1: 5.93204,
    x2: 11.1758,
    y2: 3.88164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE63A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_901_284",
    x1: 14.3801,
    y1: 22.4992,
    x2: 14.9339,
    y2: 12.8994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_901_284",
    x1: 13.4382,
    y1: 18.5651,
    x2: 16.4412,
    y2: 23.3643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE63A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.6d2d302323d3eaa382980b556b951999.svg";
export { ForwardRef as ReactComponent };